"use client";
import React from "react";

export default function getCityInfo(selectedFilter, cityname) {
  switch (selectedFilter) {
    case "School Score":
      return (
        <>
          Discover {cityname}'s top neighborhoods based on schools, using scores
          from{" "}
          <a
            href="https://www.greatschools.org/"
            target="_blank"
            title="GreatSchools.org"
          >
            GreatSchools.org
          </a>{" "}
          . Ideal for education-focused families, this list showcases areas with
          top-rated schools first.
        </>
      );

    case "Safety Score":
      return (
        <>
          Explore the neighborhoods with the lowest crime in {cityname}, based
          on available data. This list points to neighborhoods where safety and
          security take priority.
        </>
      );

    case "Amenities Score":
      return (
        <>
          Find neighborhoods in {cityname} with the best amenities, from
          shopping and dining to parks and curb appeal. This list favors
          neighborhoods where amenities are walkable, parks are inviting, and
          charm abounds.
        </>
      );

    case "Lowest Price":
      return (
        <>
          Uncover {cityname}'s most affordable neighborhoods, using a custom
          weighted median price from recent sales. This list is ideal for
          budget-conscious house hunters, revealing areas where your dollar goes
          further.
        </>
      );

    case "Highest Price":
      return (
        <>
          Discover {cityname}'s undervalued neighborhoods - this list finds the
          sweet spot of affordability, school quality, safety, and amenities.
          Uncover these hidden gems for the best value living.
        </>
      );

    case "Most Undervalued":
      return (
        <>
          Identify neighborhoods in {cityname} with the best custom weighted
          appreciation trend from recent sales data.
        </>
      );

    case "Best Appreciation":
      return (
        <>
          Here are {cityname}'s neighborhoods with the most positive
          appreciation trends, based on recent sales data. This list is
          essential to understand where values are heading, up or down, in a
          dynamic market. Delve into this list to identify which neighborhoods
          are experiencing the most pronounced shifts in value, giving you a
          clearer picture of {cityname}'s evolving real estate landscape.
        </>
      );

    default:
      return (
        <>
          Houseberry’s list of the best neighborhoods overall in {cityname},
          where we've considered data on schools, safety
        </>
      );
  }
}
